export const easeOutCubic = 'cubic-bezier(0.23, 1, 0.32, 1)';
export const animationDuration = 400;

export const transitionTimeouts = {
  enter: animationDuration,
  exit: animationDuration,
};
